import { render, staticRenderFns } from "./EntityCard.vue?vue&type=template&id=4e034222&scoped=true&"
import script from "./EntityCard.vue?vue&type=script&lang=ts&"
export * from "./EntityCard.vue?vue&type=script&lang=ts&"
import style0 from "./EntityCard.vue?vue&type=style&index=0&id=4e034222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e034222",
  null
  
)

export default component.exports